// removed by extract-text-webpack-plugin
module.exports = {"displayCard":"displayCard__1oqux","cardHeader":"cardHeader__3FXnD","cardBody":"cardBody__9E8cU"};


//////////////////
// WEBPACK FOOTER
// ./components/DisplayCard/style.css
// module id = t8vk
// module chunks = 9